const defaultFormData = {
  nocFromMunicipalCorporation: false,
  nocFromMunicipalCorporationEmployee: false,
  plotRadiusMonument: false,
  plotRadiusMonumentEmployee: false,
  plotNearCrossroad: false,
  plotNearCrossroadEmployee: false,
  plotNearIrrigationLand: false,
  plotNearIrrigationLandEmployee: false,
  plotAbuttingPWD: false,
  plotAbuttingPWDEmployee: false,
  plotNearMetro: false,
  plotNearMetroEmployee: false,
  siteNearRailwayBoundary: false,
  siteNearRailwayBoundaryEmployee: false,
  plotNearForestLand: false,
  plotNearForestLandEmployee: false,
  plotAbuttingNationalHighway: false,
  plotAbuttingNationalHighwayEmployee: false,
  useBuildingMaterial: false,
  useBuildingMaterialEmployee: false,
  plotFunnelZoneAirport: false,
  plotFunnelZoneAirportEmployee: false,
  landAcquisitionNOC: false,
  landAcquisitionNOCEmployee: false,
  nazoolDepartmentNOC: false,
  nazoolDepartmentNOCEmployee: false,
  improvementTrustNOC: false,
  improvementTrustNOCEmployee: false,
  nocFromTehsil: false,
  nocFromTehsilEmployee: false,
  propertyDepartmentNOC: false,
  propertyDepartmentNOCEmployee: false,
  ceilingDepartmentNOC: false,
  ceilingDepartmentNOCEmployee: false,
  landUseCertificate: false,
  landUseCertificateEmployee: false,
  plotNearDefenseArea: false,
  plotNearDefenseAreaEmployee: false,
  siteNearSecurityZone: false,
  siteNearSecurityZoneEmployee: false,
  siteNearGovtAuthority: false,
  siteNearGovtAuthorityEmployee: false,
  propertyAffectingRevenue: false,
  propertyAffectingRevenueEmployee: false,
  plotAdjacentUPAVP: false,
  plotAdjacentUPAVPEmployee: false,
  touristActivities: false,
  touristActivitiesEmployee: false,
  plotAbuttingMajorRoadNCR: false,
  plotAbuttingMajorRoadNCREmployee: false,
  plotNearJail: false,
  plotNearJailEmployee: false,
  siteProposingBasement: false,
  siteProposingBasementEmployee: false,
  plotApproachRoadNH: false,
  plotApproachRoadNHEmployee: false,
  propertyAllottedByUPAVP: false,
  propertyAllottedByUPAVPEmployee: false,
  attachAdditionalDocuments: false,
  attachAdditionalDocumentsEmployee: false,
  permissionElectricityProvider: false,
  permissionElectricityProviderEmployee: false,
  proposedGreenBuilding: false,
  proposedGreenBuildingEmployee: false,
  collectrateADMNOC: false,
  collectrateADMNOCEmployee: false,
  securityDepartmentNOC: false,
  securityDepartmentNOCEmployee: false,
  others: false,
  othersEmployee: false,
  reviewedDocuments: false,
  reviewedDocumentsEmployee: false,
  othersDetails: "",
};
const questions = [
  {
    label: "Does your site require NOC from Municipal Corporation?",
    applicantName: "nocFromMunicipalCorporation",
    employeeName: "nocFromMunicipalCorporationEmployee",
  },
  {
    label: "Does your plot fall under 300m radius of any monument?",
    applicantName: "plotRadiusMonument",
    employeeName: "plotRadiusMonumentEmployee",
  },
  {
    label: "Does your proposal require Fire Noc?",
    applicantName: "requireFireNoc",
    employeeName: "requireFireNocEmployee",
  },
  {
    label: "Does your proposal require Environmental clearance Noc?",
    applicantName: "environmentClearanceNoc",
    employeeName: "environmentClearanceNocEmployee",
  },
  {
    label: "Is proposed plot near major crossroad (Chauraha) or affecting traffic?",
    applicantName: "plotNearCrossroad",
    employeeName: "plotNearCrossroadEmployee",
  },
  {
    label: "Is your plot nearby irrigation land/irrigation canal?",
    applicantName: "plotNearIrrigationLand",
    employeeName: "plotNearIrrigationLandEmployee",
  },
  {
    label: "Is your plot abutting PWD Road?",
    applicantName: "plotAbuttingPWD",
    employeeName: "plotAbuttingPWDEmployee",
  },
  {
    label: "Is your plot within 100 meters of a metro structure/corridor?",
    applicantName: "plotNearMetro",
    employeeName: "plotNearMetroEmployee",
  },
  {
    label: "Is the proposed site within 30 meters of a railway line/land?",
    applicantName: "siteNearRailwayBoundary",
    employeeName: "siteNearRailwayBoundaryEmployee",
  },
  {
    label: "Is your plot near Forest Land or any Major tree which requires NOC from the forest department?",
    applicantName: "plotNearForestLand",
    employeeName: "plotNearForestLandEmployee",
  },
  {
    label: "Is your plot abutting any National Highway?",
    applicantName: "plotAbuttingNationalHighway",
    employeeName: "plotAbuttingNationalHighwayEmployee",
  },
  {
    label: "Are you planning to use boundary material on your plot (for plots larger than 2000 sq. m)?",
    applicantName: "useBuildingMaterial",
    employeeName: "useBuildingMaterialEmployee",
  },
  {
    label: "Is your plot falling in funnel zone of Airport authorities/defence airport?",
    applicantName: "plotFunnelZoneAirport",
    employeeName: "plotFunnelZoneAirportEmployee",
  },
  {
    label: "Does your site require Land Acquisition department NOC?",
    applicantName: "landAcquisitionNOC",
    employeeName: "landAcquisitionNOCEmployee",
  },
  {
    label: "Does your site require Nazool department NOC?",
    applicantName: "nazoolDepartmentNOC",
    employeeName: "nazoolDepartmentNOCEmployee",
  },
  {
    label: "Does your site require Improvement Trust NOC?",
    applicantName: "improvementTrustNOC",
    employeeName: "improvementTrustNOCEmployee",
  },
  {
    label: "Does your site require NOC from Tehsil?",
    applicantName: "nocFromTehsil",
    employeeName: "nocFromTehsilEmployee",
  },
  {
    label: "Does your site require Property Department NOC? (Is your plot Leasehold?)",
    applicantName: "propertyDepartmentNOC",
    employeeName: "propertyDepartmentNOCEmployee",
  },
  {
    label: "Does your site require Ceiling department NOC?",
    applicantName: "ceilingDepartmentNOC",
    employeeName: "ceilingDepartmentNOCEmployee",
  },
  {
    label: "Does your site require Land Use Certificate?",
    applicantName: "landUseCertificate",
    employeeName: "landUseCertificateEmployee",
  },
  {
    label: "Is your proposed plot near defence area?",
    applicantName: "plotNearDefenseArea",
    employeeName: "plotNearDefenseAreaEmployee",
  },
  {
    label: "Is your proposed site within 100 meters of any security zone?",
    applicantName: "siteNearSecurityZone",
    employeeName: "siteNearSecurityZoneEmployee",
  },
  {
    label: " Is the plot situated within 30 meters of any government authority?",
    applicantName: "siteNearGovtAuthority",
    employeeName: "siteNearGovtAuthorityEmployee",
  },
  {
    label: "Is your proposed property affecting any Administrative revenue?",
    applicantName: "propertyAffectingRevenue",
    employeeName: "propertyAffectingRevenueEmployee",
  },
  {
    label: "Is your plot adjacent to UPAVP Land?",
    applicantName: "plotAdjacentUPAVP",
    employeeName: "plotAdjacentUPAVPEmployee",
  },
  {
    label: "Are you proposing any tourist activities on your plot?",
    applicantName: "touristActivities",
    employeeName: "touristActivitiesEmployee",
  },
  {
    label: "Is your plot abutting any Major road of National Capital Region?",
    applicantName: "plotAbuttingMajorRoadNCR",
    employeeName: "plotAbuttingMajorRoadNCREmployee",
  },
  {
    label: "Is your plot within 100 meters of a jail?",
    applicantName: "plotNearJail",
    employeeName: "plotNearJailEmployee",
  },
  {
    label: "Is your proposed site not a single dwelling unit and you are proposing a basement?",
    applicantName: "siteProposingBasement",
    employeeName: "siteProposingBasementEmployee",
  },
  {
    label: "Does your plot require an approach road from any National Highway?",
    applicantName: "plotApproachRoadNH",
    employeeName: "plotApproachRoadNHEmployee",
  },
  {
    label: "Is the property allotted to you directly by the authority/UPAVP?",
    applicantName: "propertyAllottedByUPAVP",
    employeeName: "propertyAllottedByUPAVPEmployee",
  },
  {
    label: "Do you want to attach any additional documents?",
    applicantName: "attachAdditionalDocuments",
    employeeName: "attachAdditionalDocumentsEmployee",
  },
  {
    label: "Does your plot require permission from Torrent Power Limited/Any other electricity service provider?",
    applicantName: "permissionElectricityProvider",
    employeeName: "permissionElectricityProviderEmployee",
  },
  {
    label: "Is your plot proposed for Green Building?",
    applicantName: "proposedGreenBuilding",
    employeeName: "proposedGreenBuildingEmployee",
  },

  {
    label: "Does your site require NOC from the Security Department?",
    applicantName: "securityDepartmentNOC",
    employeeName: "securityDepartmentNOCEmployee",
  },
  // {
  //   label: "Other NOC",
  //   applicantName: "others",
  //   employeeName: "othersEmployee",
  // },
];

export { defaultFormData, questions };
